import LTR from "@brand-icons/ploom/hand-choose/hand-choose-ltr.svg";

import { iconFactory } from "../iconFactory";

export const HandChooseIcon = iconFactory("HandChooseIcon", LTR);
